import React from 'react';
import { observer } from 'mobx-react';
import ContractProductsModal from './ContractProductsModal';
import { toJS } from 'mobx';
import { BRAZIL } from '../../../core/consts';
import DowngradeContractFormService from '../services/DowngradeContractFormService';

class DowngradeContractProductsModalContainer extends React.Component {
  render() {
    return (
      <ContractProductsModal
        options={toJS(DowngradeContractFormService.productsService.products)}
        onChange={DowngradeContractFormService.productsService.form.setValue}
        values={DowngradeContractFormService.productsService.form.getValues()}
        onSubmit={DowngradeContractFormService.productsService.handleSubmit}
        errors={DowngradeContractFormService.productsService.form.errors}
        onDelete={DowngradeContractFormService.productsService.handleDelete}
        loading={DowngradeContractFormService.productsService.fetch.fetching}
        submitting={DowngradeContractFormService.submit.fetching}
        currencyType={
          !DowngradeContractFormService.form.getValue('country') ||
          BRAZIL.includes(DowngradeContractFormService.form.getValue('country'))
            ? 'real'
            : 'dollar'
        }
        isModalOpen={DowngradeContractFormService.productsService.isModalOpen}
        isEditing={DowngradeContractFormService.productsService.isEditing}
        type={toJS(DowngradeContractFormService.contract.type)}
        onReset={DowngradeContractFormService.productsService.form.reset}
        onClose={DowngradeContractFormService.productsService.handleToggleModal}
        onAddRange={DowngradeContractFormService.productsService.handleAddRange}
        onDeleteRange={DowngradeContractFormService.productsService.handleDeleteRange}
      />
    );
  }
}

export default observer(DowngradeContractProductsModalContainer);
